import React from 'react';
import { Link } from 'react-router-dom';

const ThemeGrid = ({ items = [] }) => {
  return (
    <div className="w-full max-w-6xl mx-auto px-4">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5"> {/* Increased the number of columns */}
        {items.map((item, index) => (
          <Link to={item?.link} key={index}>
            <div
              className="relative group cursor-pointer overflow-hidden rounded-lg aspect-[3/4]" // Maintained aspect ratio
            >
              {/* Image Container */}
              <div className="absolute inset-0">
                <img
                  src={item.imgUrl}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black opacity-70" />
              </div>

              {/* Text Container */}
              <div className="absolute bottom-0 left-0 right-0 p-3"> {/* Reduced padding */}
                <h3 className="text-white text-lg font-light"> {/* Reduced text size */}
                  {item.title}
                </h3>
              </div>

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-20 transition-opacity duration-300" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ThemeGrid;
